/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Status_StoppedInputs */

const en_admin_ai_chat_status_stopped = /** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopped`)
};

const de_admin_ai_chat_status_stopped = /** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestoppt`)
};

const es_admin_ai_chat_status_stopped = /** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detenido`)
};

const fr_admin_ai_chat_status_stopped = /** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêté`)
};

const nl_admin_ai_chat_status_stopped = /** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestopt`)
};

/** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */
const it_admin_ai_chat_status_stopped = en_admin_ai_chat_status_stopped;

/** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_status_stopped = en_admin_ai_chat_status_stopped;

/** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */
const pl_admin_ai_chat_status_stopped = en_admin_ai_chat_status_stopped;

/** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */
const hu_admin_ai_chat_status_stopped = en_admin_ai_chat_status_stopped;

/** @type {(inputs: Admin_Ai_Chat_Status_StoppedInputs) => LocalizedString} */
const ro_admin_ai_chat_status_stopped = en_admin_ai_chat_status_stopped;

/**
* | output |
* | --- |
* | "Stopped" |
*
* @param {Admin_Ai_Chat_Status_StoppedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_status_stopped = /** @type {((inputs?: Admin_Ai_Chat_Status_StoppedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Status_StoppedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_status_stopped(inputs)
	if (locale === "de") return de_admin_ai_chat_status_stopped(inputs)
	if (locale === "es") return es_admin_ai_chat_status_stopped(inputs)
	if (locale === "fr") return fr_admin_ai_chat_status_stopped(inputs)
	if (locale === "nl") return nl_admin_ai_chat_status_stopped(inputs)
	if (locale === "it") return it_admin_ai_chat_status_stopped(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_status_stopped(inputs)
	if (locale === "pl") return pl_admin_ai_chat_status_stopped(inputs)
	if (locale === "hu") return hu_admin_ai_chat_status_stopped(inputs)
	return ro_admin_ai_chat_status_stopped(inputs)
});
export { admin_ai_chat_status_stopped as "admin.ai_chat.status_stopped" }